module.exports = __webpack_public_path__ + "media/images/emblems/Sullens-coat_of_arms-baa9781ebd7dd7d830e4e517e0880061.svg";